//@flow

import type {MessageType, ChatServiceType} from '../../../../../../entities';

export const MESSAGE_FORM_FIELDS = {
  message: 'message',
  files: 'files',
  type: 'type',
  attachment: 'attachment',
};

export type MessageFormAttachment = {
  type: string,
  src: string,
  name?: string,
};
export type MessageFormFields = {
  message: string,
  files?: File[] | Blob[],
  type: MessageType,
  attachment?: MessageFormAttachment,
};

export const AUDIO_SERVICE_AVAILABLE: ChatServiceType[] = [
  /* 'WHATSAPP_WEB' */
];

export function getMessageTypeFromMime(mime: string): MessageType {
  if (mime.includes('image')) return 'IMAGE';
  if (mime.includes('video')) return 'VIDEO';
  if (mime.includes('audio')) return 'AUDIO';
  return 'DOCUMENT';
}
